import { JSX } from 'react';
import { N06MainFooter, N06MainFooterProps } from './N06MainFooter.types';
import { Footer, FooterProps, SvgIconType } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: N06MainFooterProps): JSX.Element => {
  const { renderRichText, renderText, renderImage, renderLink } = useConditionalRendering();
  const model: N06MainFooter | undefined = props?.fields?.data?.footer;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (model?.copyrightText?.jsonValue?.value) {
    model.copyrightText.jsonValue.value = model.copyrightText.jsonValue.value.replace(
      /{year}/,
      new Date().getFullYear().toString()
    );
  }

  const footerArgs: FooterProps = {
    logo: renderImage(model?.logo?.jsonValue),
    logoLink: renderLink(model?.logoLink?.jsonValue, { required: true }),
    socialMediaLinks: model?.socialMediaLinks?.targetItems?.map((item) => {
      const link = item?.link?.jsonValue?.value;
      const socialMediaType = item?.type?.jsonValue?.fields?.Value?.value as SvgIconType;
      const socialMediaTitle = item?.type?.jsonValue?.fields?.Key?.value;

      return {
        link: (
          <a
            href={`${link?.href}`}
            target={`${link?.target}`}
            title={`${socialMediaTitle}`}
            aria-label={`${socialMediaTitle}`}
          />
        ),
        iconName: socialMediaType,
      };
    }),
    bottomText: renderRichText(model?.bottomRichText?.jsonValue),
    legalSection1Text: renderRichText(model?.legalSection1Copy?.jsonValue),
    copyRightText: renderText(model?.copyrightText?.jsonValue),
    legalSection2Text: renderRichText(model?.legalSection2Copy?.jsonValue),
    footerColumn:
      model?.footerColumns?.results?.map((footerColumn) => {
        return {
          headline: renderText(footerColumn?.heading?.jsonValue),
          footerLinkItems:
            footerColumn?.footerLinkItems?.results?.map((footerLinkItem) => {
              return renderLink(footerLinkItem?.link?.jsonValue, { required: true });
            }) ?? [],
        };
      }) ?? [],
  };

  return <Footer data-elastic-exclude="" data-component={marketingRenderingName} {...footerArgs} />;
};

export default checkDatasourceForRendering<N06MainFooterProps>(Default);
